import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { clearData, getDataStorage, STORAGE } from "@utils/Storage";
import { RootState } from "store/reducer";
import { useHistoryCustom } from "shared/hook/useHistoryCustom";

const CreateReportTlogPreScreen = () => {
  const isLoggedIn = useSelector((state: RootState) => state.authInfo.loggedIn);
  const token = localStorage.getItem(STORAGE.ACCESS_TOKEN);
  const history = useHistoryCustom();

  // 報告作成データを取得
  const data_str = getDataStorage(STORAGE.EDIT_WORK_DATA, "null");
  const data = JSON.parse(data_str);

  React.useEffect(() => {
    if (data) {
      history.replace("/work/create", {
        data: data,
        referrer: "/work/create-pre",
        close_window: true,
      });
    }
    clearData(STORAGE.EDIT_WORK_DATA);
  }, []);

  if (isLoggedIn && token && data) {
    // 報告作成
    // 報告作成画面へ
    return <></>;
  } else {
    // 未ログイン
    // ログイン画面へ
    return <Redirect to="/" />;
  }
};

export default CreateReportTlogPreScreen;
